import axios from 'axios';
import {
  ResponseModel,
  SERVER_ERROR_KEY,
  deleteCookie,
  getCookie,
  handleAxiosResponse,
  handleError,
} from '@r-and-a-shared-ui/utils';
import { ENDEAVOR_ACCESS_TOKEN } from '@r-and-a-shared-ui/auth-client';
import httpErrors, { HttpError } from 'http-errors';
import { VODPlaylistInput } from '../input-schemas/playback-api-input-schema';
import { VODPlaylistResponse } from '../response-schemas/vod-playlist-response';
import { getSharedAuthToken } from '../utils/shared-token';
import { getHeader } from '../utils/queries-utils';

export type VODPlaylistResult = {
  data: VODPlaylistResponse,
  authToken?: string;
}

export const VODPlaylistQuery = async ({
  input,
}: {
  input: VODPlaylistInput;
}) => {
  try {

    const {
      playlistId,
      isAuthenticated,
      refreshToken,
      accessToken,
      idToken,
      config
    } = input;
  
    let result: ResponseModel;
    const endeavorAccessToken = getCookie(ENDEAVOR_ACCESS_TOKEN);
    
    if (!endeavorAccessToken) {
      const authToken = await getSharedAuthToken({
        isAuthenticated, refreshToken, accessToken, idToken, config
      });

      result = await getPlaylist({
        playlistId,
        ...config,
        authToken
      });

      return { data: result.data } as VODPlaylistResult;
    }
    else {
      try {
        result = await getPlaylist({
          playlistId,
          ...config,
          authToken: endeavorAccessToken
        });

        return { data:result.data } as VODPlaylistResult;
      }
      catch (error: any){
        if (error?.message?.messages[0] === 'Bearer token is not valid') {
          deleteCookie(ENDEAVOR_ACCESS_TOKEN);

          const authToken = await getSharedAuthToken({
            isAuthenticated, refreshToken, accessToken, idToken, config
          });

          result = await getPlaylist({
            playlistId,
            ...config,
            authToken
          });

          return { data: result.data } as VODPlaylistResult;
        }
        throw error;
      }
    }

  } catch (err: any) {
    console.error(`Error on Playlist By Id Query: ${err?.message || err}`);
    err.message = JSON.stringify(err?.name, err?.message);
    throw err;
  }
};

async function getPlaylist({playlistId, url, xApiKey, realm, authToken} : any) {
  const result = await axios
    .get(
      `${url}/api/v4/playlist/${playlistId}`,
      getHeader(xApiKey!, realm!, authToken)
    )
    .then(handleAxiosResponse)
    .catch(handleError);

  if (result.hasErrors) {
    const err = httpErrors?.[result?.statusCode as keyof typeof httpErrors]?.(
      result?.errorMessages?.join('\n'),
    ) as HttpError;
    err.name = result.data?.value?.errorKey || SERVER_ERROR_KEY;
    if (result?.errorMessages)
      err.message = result?.errorMessages[0];
    throw err;
  }
  return result;
}

